import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-3" }
const _hoisted_2 = { class: "text-sm text-gray-500" }
const _hoisted_3 = {
  key: 0,
  class: "px-6 py-4"
}
const _hoisted_4 = { class: "flex items-start gap-2 rounded-md bg-gray-50 p-3 text-sm text-gray-600" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "font-medium text-gray-900" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "font-medium text-gray-900" }
const _hoisted_9 = { class: "grid items-start gap-6 px-6 py-5 lg:grid-cols-[minmax(0,1fr)_320px] lg:gap-7" }
const _hoisted_10 = { class: "text-sm text-gray-500" }
const _hoisted_11 = {
  key: 0,
  class: "mt-3.5 space-y-2"
}
const _hoisted_12 = { class: "w-full max-w-[340px] lg:max-w-none" }
const _hoisted_13 = { class: "mt-2.5 flex items-center gap-1.5 text-xs text-gray-500" }
const _hoisted_14 = { class: "px-6 py-5" }
const _hoisted_15 = { class: "flex items-center justify-between gap-3" }
const _hoisted_16 = { class: "mt-2.5 block break-words rounded-md border border-gray-200 bg-gray-50 px-3 py-2.5 font-mono text-xs leading-relaxed text-gray-600" }
const _hoisted_17 = { class: "px-6 py-4" }
const _hoisted_18 = { class: "flex flex-wrap gap-2" }
const _hoisted_19 = {
  key: 0,
  class: "mt-4 space-y-5"
}
const _hoisted_20 = { class: "rounded-md border border-gray-200 bg-gray-50 p-3" }
const _hoisted_21 = { class: "mt-0.5 text-sm text-gray-500" }
const _hoisted_22 = { class: "mt-2 flex items-start gap-2" }
const _hoisted_23 = { class: "min-w-0 flex-1 break-words rounded border border-gray-200 bg-white px-2.5 py-2 font-mono text-xs leading-relaxed text-gray-600" }
const _hoisted_24 = {
  key: 0,
  class: "mt-3 border-t border-gray-200 pt-3"
}
const _hoisted_25 = { class: "mt-0.5 text-sm text-gray-500" }
const _hoisted_26 = { class: "mt-2 divide-y divide-gray-200 border-y border-gray-200" }
const _hoisted_27 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_28 = { class: "col-span-2 text-sm text-gray-500" }
const _hoisted_29 = { class: "mt-2.5 text-sm text-gray-500" }
const _hoisted_30 = {
  key: 1,
  class: "mt-4 rounded-lg border border-gray-200 bg-gray-50 p-4"
}

import {
  ArrowTopRightOnSquareIcon,
  CheckIcon,
  ClipboardDocumentIcon,
  InformationCircleIcon,
  PencilSquareIcon,
  QuestionMarkCircleIcon
} from '@heroicons/vue/20/solid'
import { computed, ref } from 'vue'

import NeueButton from '@/components/neue/NeueButton.vue'
import NeueToggle from '@/components/neue/NeueToggle.vue'
import SettingCard from '@/components/settings/SettingCard.vue'

const SIZING_EXAMPLE = `<div style="max-width: 480px; height: 600px;">
  <!-- paste the embed code here -->
</div>`


export default {
  __name: 'WebsiteChannel',
  props: {
  name: { type: String, required: true },
  description: { type: String, required: true },
  enabled: { type: Boolean, required: true },
  // The persisted switch, not the one the merchant may have just flipped: the
  // snippet is only real once the server agrees the channel is on.
  live: { type: Boolean, required: true },
  snippet: { type: String, default: '' },
  pasteGuides: { type: Array, required: true },
  pasteNote: { type: String, required: true },
  manualNote: { type: String, required: true },
  pendingNote: { type: String, required: true },
  offNote: { type: String, required: true },
  benefits: { type: Array, default: () => [] },
  syncing: { type: Boolean, default: false },
  canTry: { type: Boolean, default: false },
  sizingNote: { type: String, default: '' },
  customizeLabel: { type: String, default: 'Preview and customize' },
  embedLabel: { type: String, default: 'How to embed it in your site' }
},
  emits: ['update:enabled', 'try'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const open = ref(null)
const copied = ref(false)

const status = computed(() => {
  if (props.enabled && props.live) return { dot: 'bg-green-500', label: 'Ready for inquiries' }
  if (props.enabled) return { dot: 'bg-amber-400', label: props.syncing ? 'Switching on…' : 'Not taking inquiries yet' }
  if (props.live) {
    return props.syncing
      ? { dot: 'bg-gray-300', label: 'Switching off…' }
      : { dot: 'bg-amber-400', label: 'Still taking inquiries' }
  }
  return { dot: 'bg-gray-300', label: 'Switched off' }
})

const toggle = which => (open.value = open.value === which ? null : which)

const copy = () => {
  if (!props.snippet) return

  navigator.clipboard.writeText(props.snippet).then(() => {
    copied.value = true
    setTimeout(() => (copied.value = false), 1600)
  })
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SettingCard, { name: __props.name }, {
    action: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(NeueToggle, {
          "model-value": __props.enabled,
          compact: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (emit('update:enabled', $event)))
        }, null, 8, ["model-value"]),
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.enabled ? 'On' : 'Off'), 1)
      ])
    ]),
    default: _withCtx(() => [
      (!__props.live && !(__props.syncing && __props.enabled))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(InformationCircleIcon), {
                class: "mt-0.5 h-4 w-4 shrink-0 text-gray-400",
                "aria-hidden": "true"
              }),
              (__props.enabled)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _createElementVNode("b", _hoisted_6, _toDisplayString(__props.pendingNote), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createElementVNode("b", _hoisted_8, _toDisplayString(__props.offNote), 1),
                    _cache[4] || (_cache[4] = _createTextVNode(" Switch it on to get the embed code and customize it. ", -1))
                  ]))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(__props.description), 1),
          (__props.benefits.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.benefits, (benefit) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: benefit,
                    class: "flex items-start gap-2 text-sm text-gray-700"
                  }, [
                    _createVNode(_unref(CheckIcon), {
                      class: "mt-0.5 h-4 w-4 shrink-0 text-gray-400",
                      "aria-hidden": "true"
                    }),
                    _createElementVNode("span", null, _toDisplayString(benefit), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: _normalizeClass(["transition duration-200", !__props.enabled && 'opacity-50 grayscale'])
          }, [
            _renderSlot(_ctx.$slots, "mini")
          ], 2),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", {
              class: _normalizeClass(["h-1.5 w-1.5 shrink-0 rounded-full", status.value.dot]),
              "aria-hidden": "true"
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(status.value.label), 1)
          ])
        ])
      ]),
      _renderSlot(_ctx.$slots, "report"),
      (__props.enabled)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-sm font-medium text-gray-900" }, "Embed code", -1)),
                _createVNode(NeueButton, {
                  type: "primary",
                  disabled: !__props.snippet,
                  onClick: copy
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ClipboardDocumentIcon), {
                      class: "mr-1.5 h-4 w-4",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(" " + _toDisplayString(copied.value ? 'Copied' : 'Copy code'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _createElementVNode("code", _hoisted_16, _toDisplayString(__props.snippet), 1),
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mt-1.5 text-sm text-gray-500" }, "Contains your key. Don't edit it.", -1))
            ]),
            _renderSlot(_ctx.$slots, "extra"),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(NeueButton, {
                  type: open.value === 'paste' ? 'cream' : 'ghost',
                  size: "sm",
                  "aria-expanded": open.value === 'paste',
                  onClick: _cache[1] || (_cache[1] = $event => (toggle('paste')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(QuestionMarkCircleIcon), {
                      class: "mr-1.5 h-4 w-4",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(" " + _toDisplayString(__props.embedLabel), 1)
                  ]),
                  _: 1
                }, 8, ["type", "aria-expanded"]),
                _createVNode(NeueButton, {
                  type: open.value === 'customize' ? 'cream' : 'ghost',
                  size: "sm",
                  "aria-expanded": open.value === 'customize',
                  onClick: _cache[2] || (_cache[2] = $event => (toggle('customize')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(PencilSquareIcon), {
                      class: "mr-1.5 h-4 w-4",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(" " + _toDisplayString(__props.customizeLabel), 1)
                  ]),
                  _: 1
                }, 8, ["type", "aria-expanded"]),
                (__props.canTry)
                  ? (_openBlock(), _createBlock(NeueButton, {
                      key: 0,
                      type: "ghost",
                      size: "sm",
                      disabled: !__props.live,
                      title: __props.live ? null : 'Try it once it is taking inquiries.',
                      onClick: _cache[3] || (_cache[3] = $event => (emit('try')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowTopRightOnSquareIcon), {
                          class: "mr-1.5 h-4 w-4",
                          "aria-hidden": "true"
                        }),
                        _cache[7] || (_cache[7] = _createTextVNode(" Try it on a test page ", -1))
                      ]),
                      _: 1
                    }, 8, ["disabled", "title"]))
                  : _createCommentVNode("", true)
              ]),
              (open.value === 'paste')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-sm font-medium text-gray-900" }, "Add it to your site", -1)),
                      _createElementVNode("p", _hoisted_21, _toDisplayString(__props.manualNote), 1),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("code", _hoisted_23, _toDisplayString(__props.snippet), 1),
                        _createVNode(NeueButton, {
                          type: "secondary",
                          size: "sm",
                          disabled: !__props.snippet,
                          onClick: copy
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(copied.value ? 'Copied' : 'Copy'), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      (__props.sizingNote)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-sm font-medium text-gray-900" }, "Want it a certain size?", -1)),
                            _createElementVNode("p", _hoisted_25, _toDisplayString(__props.sizingNote), 1),
                            _createElementVNode("pre", { class: "mt-2 overflow-x-auto rounded border border-gray-200 bg-white px-2.5 py-2 font-mono text-xs leading-relaxed text-gray-600" }, _toDisplayString(SIZING_EXAMPLE))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-sm font-medium text-gray-900" }, "Using a website builder?", -1)),
                      _createElementVNode("dl", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pasteGuides, (guide) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: guide.platform,
                            class: "grid grid-cols-3 gap-4 py-2.5"
                          }, [
                            _createElementVNode("dt", _hoisted_27, _toDisplayString(guide.platform), 1),
                            _createElementVNode("dd", _hoisted_28, _toDisplayString(guide.steps), 1)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("p", _hoisted_29, _toDisplayString(__props.pasteNote), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (open.value === 'customize')
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _renderSlot(_ctx.$slots, "customize")
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["name"]))
}
}

}